export const linkedinConversions = {
  b2cJobsOnboardingComplete: 9968108,
  b2cGeneralOnboardingComplete: 9967700,
  b2cCompletedOnboarding: 8217908,
  b2cSignUp: 8217900,
  b2cLead: 8568252,
};
